module.exports = __webpack_public_path__ + "img/animoca.8a35e922.png";